import { Skeleton } from 'primereact/skeleton'

/**
 * Paylaşılan KPI / özet satırı (Reuse Mandate — tek kaynak). Anayasa (Page Standards → "Uygulama Kabuğu
 * ve Düzen") **iki tanımlı varyant** tanır; küme kapalıdır, üçüncü bir görünüm anayasa değişikliği ister:
 *
 * - **`plain` (varsayılan):** liste/yönetim ekranlarının görünümü — kart kutusu/kenarlık/gölge, ton ikon
 *   kutusu ve sparkline YOK; yalnız etiket + büyük değer, satırın üstünde ve altında içerik-genişliği
 *   ayraç çizgisi. `hint`/`tone` bu varyantta **yok sayılır** (görünüm birebir korunur — mevcut
 *   çağıranlar değişmez).
 * - **`boxed` (pano/dashboard):** her ölçüt kendi kart kutusunda; etiket + büyük değer + kısa `hint`
 *   satırı, esnek kolon düzeni (dörtten fazla ölçüt sarabilir).
 *
 * İki varyantta da etiketin yanında ikon yoktur: eskiden `plain`'de duran info + chevron ikonları hiçbir
 * işleve bağlı değildi ve buton gibi görünüyordu (kullanıcı bildirimi 2026-10-21).
 *
 * İçerik prop'lardan gelir; `loading` iken değer yerine skeleton (0 yanıp sönmesi olmaz).
 */
export interface KpiCard {
  key: string
  label: string
  value: string
  /** Değerin altındaki kısa açıklama (ör. "termin tarihi geçti"). Yalnız `boxed` varyantında gösterilir. */
  hint?: string
  /** Vurgu tonu; `danger` uyarı/kırmızı ailesini kullanır. Yalnız `boxed` varyantında etkilidir. */
  tone?: 'default' | 'danger'
}

export interface KpiCardsProps {
  cards: KpiCard[]
  /** API'den değerler yüklenirken değer alanında skeleton gösterilir. */
  loading?: boolean
  /** Görünüm varyantı; varsayılan `plain` (mevcut ekranların görünümü). */
  variant?: 'plain' | 'boxed'
}

export default function KpiCards({ cards, loading = false, variant = 'plain' }: Readonly<KpiCardsProps>) {
  const boxed = variant === 'boxed'
  return (
    <div className={boxed ? 'ui-kpis ui-kpis--boxed' : 'ui-kpis'}>
      {cards.map((c) => (
        <div
          key={c.key}
          className={boxed && c.tone === 'danger' ? 'ui-kpi ui-kpi--danger' : 'ui-kpi'}
        >
          <div className="ui-kpi-label">
            <span>{c.label}</span>
          </div>
          <div className="ui-kpi-value">
            {loading ? <Skeleton width="3.5rem" height="1.6rem" /> : c.value}
          </div>
          {boxed && c.hint && (
            <div className="ui-kpi-hint">
              {loading ? <Skeleton width="6rem" height="0.8rem" /> : c.hint}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
